import _ from 'lodash';
import {newFeatureGroupActionTypes as actionTypes } from './NewFeatureGroupActions';

const initialState = {
  newFeatureGroups: []
};

export default function newFeatureGroupReducer(state = initialState, action) {
  var newState = {...state};
  switch(action.type) {
    case actionTypes.LOAD:
      newState.newFeatureGroups = [];
      if(action.payload.pendingFeatureGroups && action.payload.pendingFeatureGroups.length > 0) {
        action.payload.pendingFeatureGroups.forEach(pfg => {
          let fgm = _.find(action.payload.featureGroupMeta, f => f.id == pfg.fabricatorFeatureGroupMeta_Id);
          if(fgm) {
            newState.newFeatureGroups.push({
              name: fgm.featureGroup,
              customDisplayName: fgm.customDisplayName,
              customDescription: fgm.customDescription,
              unitText: fgm.unitText,
              customImageUrl: fgm.customImageUrl,
              enabled: fgm.enabled,
              visible: fgm.visible
            });
          }
        });
      }
    break;
    case actionTypes.ADD:
      newState.newFeatureGroups.unshift({
        name: action.payload.name,
        customDisplayName: action.payload.name,
        customDescription: action.payload.description,
        unitText: action.payload.unitText,
        customImageUrl: action.payload.image,
        enabled: true,
        visible: true,
        unsaved: true
      });
    break;
  }
  return newState;
}
